// https://day.js.org/docs/en/parse/string
import dayjs from 'dayjs';

export const MAINTENANCE_CONFIG = {
  preStartTime: '2025-05-29T08:00:00+10:00',
  startTime: '2025-05-31T12:00:00+10:00',
  endTime: '2025-05-31T13:00:00+10:00'
};

export const getMaintenanceFormattedTime = () => {
  // TODO: temporary as this is not maintainable once time crosses with other day
  const maintenanceStartTime = dayjs(MAINTENANCE_CONFIG.startTime).format(`HH:mm`);
  const maintenanceEndTime = dayjs(MAINTENANCE_CONFIG.endTime).format(`HH:mm`);
  const maintenanceDay = dayjs(MAINTENANCE_CONFIG.endTime).format(`ddd, D MMM YYYY`);

  return {
    maintenanceStartTime,
    maintenanceEndTime,
    maintenanceDay
  };
};
